var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStroopwafel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 3.12718C12.8443 3.04361 12.4265 3 12 3C11.5735 3 11.1557 3.04361 10.75 3.12719V6.25H13.25V3.12718Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7.75H10.75V10H13.25V7.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 10V7.75H18.4249C18.7052 8.45193 18.9019 9.20762 19 10H14.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 6.25V3.64051C15.9042 4.20364 16.9019 5.1105 17.6469 6.25H14.75Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35309 6.25C7.09817 5.1105 8.09588 4.20364 9.25003 3.64051V6.25H6.35309Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57513 7.75H9.25V10H5C5.09814 9.20762 5.29478 8.45193 5.57513 7.75Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 22.9704C11.8526 23.0662 11.4059 22.9296 11.1487 22.5608L4.17956 12.5658C3.71547 11.9002 4.20488 11 5.03084 11H18.9692C19.7951 11 20.2845 11.9002 19.8204 12.5658L19.3433 13.25H14C13.0335 13.25 12.25 14.0335 12.25 15V22.9704Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2975 14.75L13.75 21.2719V15C13.75 14.8619 13.8619 14.75 14 14.75H18.2975Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroopwafel);
export default __webpack_public_path__ + "static/media/stroopwafel.312167cff68b3a85c6461dfe1cdb485f.svg";
export { ForwardRef as ReactComponent };